import { IJxtBookingTitle } from './types';

const JxtBookingTitle = ({ title }: IJxtBookingTitle) => {
  return (
    <div className="flex items-center gap-2">
      <div className="h-6 w-5 flex items-center justify-center">
        <i className="fas fa-quote-left fa-fw fa-lg text-neutral-60" />
      </div>
      <span className="text-body-m text-neutral-140 truncate" title={title}>
        {title}
      </span>
    </div>
  );
};

export default JxtBookingTitle;
